/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DepartmentDTO,
    DepartmentDTOFromJSON,
    DepartmentDTOFromJSONTyped,
    DepartmentDTOToJSON,
} from './DepartmentDTO';
import {
    FacultyDTO,
    FacultyDTOFromJSON,
    FacultyDTOFromJSONTyped,
    FacultyDTOToJSON,
} from './FacultyDTO';
import {
    LearningCompetenceDTO,
    LearningCompetenceDTOFromJSON,
    LearningCompetenceDTOFromJSONTyped,
    LearningCompetenceDTOToJSON,
} from './LearningCompetenceDTO';
import {
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumFromJSONTyped,
    StudyCycleEnumToJSON,
} from './StudyCycleEnum';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';
import {
    SubjectDTO,
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
} from './SubjectDTO';

/**
 * 
 * @export
 * @interface StudyPlanDTO
 */
export interface StudyPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof StudyPlanDTO
     */
    planYear?: number;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof StudyPlanDTO
     */
    status?: StudyPlanStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlanDTO
     */
    approvalDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    departmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    facultyId?: string;
    /**
     * 
     * @type {DepartmentDTO}
     * @memberof StudyPlanDTO
     */
    department?: DepartmentDTO;
    /**
     * 
     * @type {FacultyDTO}
     * @memberof StudyPlanDTO
     */
    faculty?: FacultyDTO;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof StudyPlanDTO
     */
    subjects?: Array<SubjectDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    programName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StudyPlanDTO
     */
    endPlanYear?: number;
    /**
     * 
     * @type {StudyCycleEnum}
     * @memberof StudyPlanDTO
     */
    studyCycle?: StudyCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    mission?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    objective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    ocupationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanDTO
     */
    codCOR?: string | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    programProfessionalCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    programTransversalCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    programKeyCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    programGreenCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    programDigitalCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    learningKnowledgeOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    learningSkillOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyPlanDTO
     */
    learningResponsabilityOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyPlanDTO
     */
    selectedKeyCompetenceTemplateIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyPlanDTO
     */
    selectedGreenCompetenceTemplateIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyPlanDTO
     */
    selectedDigitalCompetenceTemplateIds?: Array<string> | null;
}

export function StudyPlanDTOFromJSON(json: any): StudyPlanDTO {
    return StudyPlanDTOFromJSONTyped(json, false);
}

export function StudyPlanDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyPlanDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'planYear': !exists(json, 'planYear') ? undefined : json['planYear'],
        'status': !exists(json, 'status') ? undefined : StudyPlanStatusEnumFromJSON(json['status']),
        'approvalDate': !exists(json, 'approvalDate') ? undefined : (new Date(json['approvalDate'])),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'facultyId': !exists(json, 'facultyId') ? undefined : json['facultyId'],
        'department': !exists(json, 'department') ? undefined : DepartmentDTOFromJSON(json['department']),
        'faculty': !exists(json, 'faculty') ? undefined : FacultyDTOFromJSON(json['faculty']),
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectDTOFromJSON)),
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'endPlanYear': !exists(json, 'endPlanYear') ? undefined : json['endPlanYear'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : StudyCycleEnumFromJSON(json['studyCycle']),
        'mission': !exists(json, 'mission') ? undefined : json['mission'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'ocupationName': !exists(json, 'ocupationName') ? undefined : json['ocupationName'],
        'codCOR': !exists(json, 'codCOR') ? undefined : json['codCOR'],
        'programProfessionalCompetences': !exists(json, 'programProfessionalCompetences') ? undefined : (json['programProfessionalCompetences'] === null ? null : (json['programProfessionalCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programTransversalCompetences': !exists(json, 'programTransversalCompetences') ? undefined : (json['programTransversalCompetences'] === null ? null : (json['programTransversalCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programKeyCompetences': !exists(json, 'programKeyCompetences') ? undefined : (json['programKeyCompetences'] === null ? null : (json['programKeyCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programGreenCompetences': !exists(json, 'programGreenCompetences') ? undefined : (json['programGreenCompetences'] === null ? null : (json['programGreenCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programDigitalCompetences': !exists(json, 'programDigitalCompetences') ? undefined : (json['programDigitalCompetences'] === null ? null : (json['programDigitalCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningKnowledgeOutcome': !exists(json, 'learningKnowledgeOutcome') ? undefined : (json['learningKnowledgeOutcome'] === null ? null : (json['learningKnowledgeOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningSkillOutcome': !exists(json, 'learningSkillOutcome') ? undefined : (json['learningSkillOutcome'] === null ? null : (json['learningSkillOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningResponsabilityOutcome': !exists(json, 'learningResponsabilityOutcome') ? undefined : (json['learningResponsabilityOutcome'] === null ? null : (json['learningResponsabilityOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'selectedKeyCompetenceTemplateIds': !exists(json, 'selectedKeyCompetenceTemplateIds') ? undefined : json['selectedKeyCompetenceTemplateIds'],
        'selectedGreenCompetenceTemplateIds': !exists(json, 'selectedGreenCompetenceTemplateIds') ? undefined : json['selectedGreenCompetenceTemplateIds'],
        'selectedDigitalCompetenceTemplateIds': !exists(json, 'selectedDigitalCompetenceTemplateIds') ? undefined : json['selectedDigitalCompetenceTemplateIds'],
    };
}

export function StudyPlanDTOToJSON(value?: StudyPlanDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'planYear': value.planYear,
        'status': StudyPlanStatusEnumToJSON(value.status),
        'approvalDate': value.approvalDate === undefined ? undefined : (value.approvalDate.toISOString()),
        'studyProgramId': value.studyProgramId,
        'departmentId': value.departmentId,
        'facultyId': value.facultyId,
        'department': DepartmentDTOToJSON(value.department),
        'faculty': FacultyDTOToJSON(value.faculty),
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectDTOToJSON)),
        'fileName': value.fileName,
        'programName': value.programName,
        'endPlanYear': value.endPlanYear,
        'studyCycle': StudyCycleEnumToJSON(value.studyCycle),
        'mission': value.mission,
        'objective': value.objective,
        'ocupationName': value.ocupationName,
        'codCOR': value.codCOR,
        'programProfessionalCompetences': value.programProfessionalCompetences === undefined ? undefined : (value.programProfessionalCompetences === null ? null : (value.programProfessionalCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programTransversalCompetences': value.programTransversalCompetences === undefined ? undefined : (value.programTransversalCompetences === null ? null : (value.programTransversalCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programKeyCompetences': value.programKeyCompetences === undefined ? undefined : (value.programKeyCompetences === null ? null : (value.programKeyCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programGreenCompetences': value.programGreenCompetences === undefined ? undefined : (value.programGreenCompetences === null ? null : (value.programGreenCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programDigitalCompetences': value.programDigitalCompetences === undefined ? undefined : (value.programDigitalCompetences === null ? null : (value.programDigitalCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningKnowledgeOutcome': value.learningKnowledgeOutcome === undefined ? undefined : (value.learningKnowledgeOutcome === null ? null : (value.learningKnowledgeOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningSkillOutcome': value.learningSkillOutcome === undefined ? undefined : (value.learningSkillOutcome === null ? null : (value.learningSkillOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningResponsabilityOutcome': value.learningResponsabilityOutcome === undefined ? undefined : (value.learningResponsabilityOutcome === null ? null : (value.learningResponsabilityOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'selectedKeyCompetenceTemplateIds': value.selectedKeyCompetenceTemplateIds,
        'selectedGreenCompetenceTemplateIds': value.selectedGreenCompetenceTemplateIds,
        'selectedDigitalCompetenceTemplateIds': value.selectedDigitalCompetenceTemplateIds,
    };
}

